import { Skeleton } from '@/components/ui/skeleton';

export function ItineraryDetailsSkeleton() {
    return (
        <div className="container mx-auto">
            <div className="w-full max-w-6xl mt-8 space-y-8">
                <div className="flex justify-between items-start">
                    <div className="space-y-2">
                        <Skeleton className="h-10 w-80" />
                        <Skeleton className="h-5 w-60" />
                    </div>
                    <Skeleton className="h-10 w-36" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="md:col-span-1 space-y-4">
                         <Skeleton className="h-8 w-1/3" />
                         <div className="space-y-2">
                            <Skeleton className="h-10 w-full" />
                            <Skeleton className="h-10 w-full" />
                            <Skeleton className="h-10 w-full" />
                         </div>
                         <Skeleton className="h-96 w-full" />
                    </div>
                    <div className="md:col-span-2">
                        <Skeleton className="h-[600px] w-full" />
                    </div>
                </div>
            </div>
        </div>
    )
}
